function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M290.25,429.72v-18h11.53l4.59,5.06V429.7Zm1-17v16l14.13,0V417.2l-4-4.44Z",
  transform: "translate(-290.25 -411.76)"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  fill: "#434546",
  points: "15.83 5.75 10.71 5.75 10.71 0.69 11.71 0.69 11.71 4.75 15.83 4.75 15.83 5.75"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  fill: "#434546",
  d: "M301,422.76a3.83,3.83,0,0,0,.51-1.68,2.35,2.35,0,0,0-.25-1.17,3.3,3.3,0,0,0-1.27-1.26,3.6,3.6,0,0,1-.94-.8l0-.06a1.57,1.57,0,0,1-.33-.59.36.36,0,0,0-.38-.3.35.35,0,0,0-.33.35v6.31a2,2,0,0,0-1.06-.29,1.45,1.45,0,1,0,1.77,1.42v-4.13a2.55,2.55,0,0,1,1.64,1.93,2,2,0,0,1-.14.19.35.35,0,0,0,.53.47,2.63,2.63,0,0,0,.26-.37Z",
  transform: "translate(-290.25 -411.76)"
});

var SvgFilesListingMusic = function SvgFilesListingMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.13 17.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_music.4202ec26.svg";
export { ForwardRef as ReactComponent };